import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSessionJWT, useSessionCtx } from "utils";
import { sendEmailVerificationCode } from "./index.js";

export default function useSendEmailVerificationCode() {
  const queryClient = useQueryClient();
  const { sessionJWT } = useSessionJWT();
  const { sessionId } = useSessionCtx();
  const ctx = {
    ...sessionJWT,
    sessionId,
  };

  return useMutation({
    mutationFn: ({ email }) => sendEmailVerificationCode(ctx, email),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["email-verification"] });
    },
  });
}
